module.exports = __webpack_public_path__ + "img/aztec_900.0d795268.png";